export default __webpack_public_path__ + "static/media/koszka_ze_slomy.933fc336.svg";